<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.mm_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="mm_name">
            <label class="weui-form-preview__label">{{customLabel.mm_name || "模具名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_name}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_spec">
            <label class="weui-form-preview__label">{{customLabel.mm_spec || "模具规格"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_spec}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_class">
            <label class="weui-form-preview__label">{{customLabel.mm_class || "模具类别"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_class}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_number">
            <label class="weui-form-preview__label">{{customLabel.mm_number || "模数"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_number}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_custname">
            <label class="weui-form-preview__label">{{customLabel.mm_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_custname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_maintenance">
            <label class="weui-form-preview__label">{{customLabel.mm_maintenance || "保养周期"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_maintenance}} {{ form.main.mm_maintenance_unit }}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_lifespan">
            <label class="weui-form-preview__label">{{customLabel.mm_lifespan || "设计寿命（次）"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_lifespan}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_uselifespan">
            <label class="weui-form-preview__label">{{customLabel.mm_uselifespan || "使用寿命（次）"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_uselifespan}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_uselifespan">
            <label class="weui-form-preview__label">{{customLabel.mm_uselifespan || "剩余寿命（次）"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_lifespan - form.main.mm_uselifespan}}</em>
          </div>
          <div class="weui-form-preview__item" slot="mm_lastuse">
            <label class="weui-form-preview__label">{{customLabel.mm_lastuse || "最近使用日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.mm_lastuse}}</span>
          </div>
          <div class="weui-form-preview__item" slot="mm_type">
            <label class="weui-form-preview__label">{{customLabel.mm_type || "生产属性"}}</label>
            <em class="weui-form-preview__value">{{form.main.mm_type ? '按重量' : '按面积'}}</em>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.md_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_code">
              <label class="weui-form-preview__label">{{customLabel.pr_code || "产品"}}</label>
              <span
                class="weui-form-preview__value"
              >{{item.productDTO.pr_code}} {{item.productDTO.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_brand" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_length">
              <label class="weui-form-preview__label">{{customLabel.pr_length || "长"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_length}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_width">
              <label class="weui-form-preview__label">{{customLabel.pr_width || "宽"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_width}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_height">
              <label class="weui-form-preview__label">{{customLabel.pr_height || "厚"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_height}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_weight">
              <label class="weui-form-preview__label">{{customLabel.pr_weight || "重"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_weight}} kg</span>
            </div>
            <div class="weui-form-preview__item" slot="md_distance">
              <label class="weui-form-preview__label">{{customLabel.md_distance || "跳矩"}}</label>
              <span class="weui-form-preview__value">{{item.md_distance}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_number">
              <label class="weui-form-preview__label">{{customLabel.md_number || "模数"}}</label>
              <span class="weui-form-preview__value">{{item.md_number}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_son_mold">
              <label class="weui-form-preview__label">{{customLabel.md_son_mold || "子模具编号"}}</label>
              <span class="weui-form-preview__value">{{item.md_son_mold}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_son_moldname">
              <label class="weui-form-preview__label">{{customLabel.md_son_moldname || "子模具名称"}}</label>
              <span class="weui-form-preview__value">{{item.md_son_moldname}}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <file-list v-model="form.main.mm_attach" />

      <!-- <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.pi_remark}}</span>
          </div>
        </div>
      </div> -->
    </div>
    <div class="footer-bar weui-dialog__ft">
      <router-link
        :to="'/production/make_mold_edit?id=' + form.main.id"
        v-if="form.main.mm_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="form.main.mm_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="form.main.mm_status == '已审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="form.main.mm_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Collapse from "@/components/Collapse.vue";
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Collapse,
    FileList
  },
  data() {
    return {
      baseUrl: "/api/make/makemold",
      codeField: "mm_code",
      caller: "MakeMold",
      xtype: "make-makemold-formpanel",
    };
  },
  methods: {
    p_remove() {
      const me = this

      me.$weui.confirm('确定删除单据？', function () {
        me.$loading({
          url: `/api/make/makemold/delete/${me.form.main.id}?caller=MakeMold`,
          method: "POST"
        }).then(res => {
          if(res.success) {
            me.$router.back()
          }
        })
      });
    }
  }
};
</script>